// Governance (CCD-2609): a stage gate's status may only change via its approval workflow.
export const STAGE_GATE_OBJECT_TYPE = "stage_gate";
